import { addMasterBlock, addMasterBlockFile } from 'client/actions/blockActions'
import { markAsMasterBlock } from 'client/actions/entityActions'
import * as blockApi from 'client/api/blockApi'
import { cloneStructure } from 'client/utils/cloneStructure'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { useActions } from 'common/hooks/useActions'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

interface CreateMasterBlockParams {
  blockEntities: BaseEntityNewInterface[]
  entityId: EntityIdType
  files: File[]
  locale: PageLocaleEnum
  title: string
  entity: BaseEntityNewInterface
}

export const useCreateMasterBlock = () => {
  const addBlock = useActions(addMasterBlock)
  const addFile = useActions(addMasterBlockFile)
  const markAsMaster = useActions(markAsMasterBlock)

  const createMasterBlock = async ({
    blockEntities,
    entityId,
    files,
    locale,
    title,
    entity,
  }: CreateMasterBlockParams) => {
    const { structure } = cloneStructure({
      sourceEntity: entity,
      descendants: blockEntities.filter(be => be.id !== entity.id),
    })

    const screenshotRes = await blockApi.screenshotCreate(
      blockEntities,
      entityId,
      files,
      locale,
    )

    const { data } = await blockApi.createMasterBlock(
      Object.values(structure),
      screenshotRes.data,
      title,
    )
    markAsMaster(entityId, data.block.id)
    addBlock(data.block)
    addFile(data.desktopPreview)
    return data
  }

  return {
    createMasterBlock,
  }
}
